import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import Request from "common/Request";
import NVPieChart from "common/graphs/NVPieChart";
import ActionsContext from "common/ActionsContext";
import BqnContext from "common/BqnContext";
import ColumnsGrid from "common/layouts/ColumnsGrid";

const BigGraph = styled.div`
  &,
  & svg {
    min-height: 12cm;
  }
  @media print {
    width: 100% !important;
    overflow: hidden;
  }
  .align-right {
    float: right;
  }
`;

const valueFrom = (field) => (d) => d[field];

const sessionsTooltip =
  (units = "sessions") =>
  (d) =>
    d === null ? "N/A" : `${d} ${units}`;

const ReportResult = ({
  itemsValueFrom = "active",
  connections = [],
  yAxisUnits = "sessions",
}) => {
  const {
    clusterStatus: { mode }, bqnId
} = useContext(BqnContext);

  if(mode === 'standalone'){
    return <BigGraph className="big graph">
      <NVPieChart
        items={connections}
        xFrom={(d) => d.name}
        yFrom={valueFrom(itemsValueFrom)}
        yTooltipFormat={sessionsTooltip(yAxisUnits)}
        yAxisUnits={yAxisUnits}
        labelType="value"
        yAxisFormat={d => d}
      />
    </BigGraph>
  }

  const connectionsMap = {};
  connections.forEach((connection) => {
    if (connectionsMap[connection.BQN]) {
      connectionsMap[connection.BQN].push(connection);
    } else {
      connectionsMap[connection.BQN] = [connection];
    }
  });

  const bqns = Object.keys(connectionsMap)
  .filter((bqn) => bqnId === "all" || Number(bqnId) === Number(bqn));

  return (
    <ColumnsGrid columns={Math.min(3, bqns.length)}>
      {bqns.map((bqnId) => (
          <div key={bqnId}>
            <h4> BQN {bqnId}</h4>
            <BigGraph className="big graph">
              <NVPieChart
                items={connectionsMap[bqnId]}
                xFrom={(d) => d.name}
                yFrom={valueFrom(itemsValueFrom)}
                yTooltipFormat={sessionsTooltip(yAxisUnits)}
                yAxisUnits={yAxisUnits}
                labelType="value"
                yAxisFormat={d => d}
              />
            </BigGraph>
          </div>
        ))}
    </ColumnsGrid>
  );
}

const thoseActive = ({ active = 0 }) => active > 0;

const Report = ({ retrieval }) => {
  const [request, setRequest] = useState(null);
  const actions = useContext(ActionsContext);
  const doLoad = () => {
    setRequest(retrieval());
  };
  useEffect(() => (doLoad(), actions.recv("do-load", doLoad)), []);
  return request === null ? null : (
    <Request during={request}>
      {({ connections }) => (
        <ReportResult connections={connections.filter(thoseActive)}/>
      )}
    </Request>
  );
};

export default Report;
